// extracted by mini-css-extract-plugin
export var statItem = "_ll-1";
export var statsRow = "_ll-0";